import { ToolkitItem } from '@/lib/sanity/queries/get-toolkit-item';
import { ToolkitItemLink } from '../toolkit-item-link';
import { ToolkitIcon } from './toolkit-items/icon';
import { Box } from '../box';
import { Text } from '../text';
import { ArrowRight } from '../icons';
import { CSS } from '@/stitches.config';
import { useState } from 'react';

interface ToolkitGridItemProps {
  toolkitItem: ToolkitItem;
  css?: CSS;
}

function ToolkitGridItemContent({ toolkitItem, css }: ToolkitGridItemProps) {
  return (
    <Box
      css={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'space-between',
        backgroundColor: '$background',
        ...css,
      }}
    >
      <Box
        css={{
          padding: '$3',
          pb: 0,
          '& svg': {
            width: '4.5rem',
          },
        }}
      >
        <ToolkitIcon includeBackground={false} item={toolkitItem} />{' '}
      </Box>
      <Box css={{ padding: '$4', pt: 0 }}>
        <Text size={3}>{toolkitItem.name}</Text>
        <ArrowRight width={18} height={18} />
      </Box>
    </Box>
  );
}

export function ToolkitGridItem({ toolkitItem, css }: ToolkitGridItemProps) {
  const [isActive, setIsActive] = useState(false);

  return (
    <ToolkitItemLink
      key={toolkitItem._id}
      toolkitItem={toolkitItem}
      css={{
        position: 'relative',
        display: 'block',
        color: '$foreground',
        textDecoration: 'none',
        ...css,
      }}
      onActivate={() => setIsActive(true)}
      onDeactivate={() => setIsActive(false)}
    >
      <Box
        css={{
          position: 'absolute',
          top: '-0.5px',
          left: '-0.5px',
          width: 'calc(100% + 1px)',
          height: 'calc(100% + 1px)',
          border: '1px rgb(150,150,150) solid',
          zIndex: 1,
        }}
      />
      <ToolkitGridItemContent toolkitItem={toolkitItem} />
      <ToolkitGridItemContent
        toolkitItem={toolkitItem}
        css={{
          filter: 'invert(1)',
          clipPath: isActive
            ? 'polygon(0 100%, calc(50% + 1px) 100%, calc(50% + 1px) 0, 0 0)'
            : 'polygon(0 100%, calc(50% + 1px) 100%, calc(50% + 1px) 100%, 0 100%)',
          transition: 'clip-path 0.5s',
          pointerEvents: 'none',
        }}
        aria-hidden
      />
      <ToolkitGridItemContent
        toolkitItem={toolkitItem}
        css={{
          filter: 'invert(1)',
          clipPath: isActive
            ? 'polygon(50% 100%, 100% 100%, 100% 0, 50% 0)'
            : 'polygon(50% 100%, 100% 100%, 100% 100%, 50% 100%)',
          transition: 'clip-path 0.4s 0.1s',
          pointerEvents: 'none',
        }}
        aria-hidden
      />
    </ToolkitItemLink>
  );
}
